import { AllDocsResponse, Document, RowValue } from "@budibase/types"

export function pagination<T extends Document | RowValue>(
  response: AllDocsResponse<T>,
  opts?: { paginate?: boolean; pageSize: number }
): { data: T[]; hasNextPage: boolean; nextPage?: string } {
  const data = response.rows.map((row: any) => {
    return row.doc ? row.doc : row
  })
  if (!opts?.paginate) {
    return { data, hasNextPage: false }
  }
  const hasNextPage = data.length > opts?.pageSize
  return {
    data: data.slice(0, opts?.pageSize),
    hasNextPage,
    nextPage: hasNextPage ? response.rows[opts?.pageSize]?.key : undefined,
  }
}
